<template>
    <tr @click="goToUserPage(user.id)">
        <td class="is-hidden-touch">{{ user.id }}</td>
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td><p v-for="role in user.roles">{{ role.name }}</p></td>
        <td class="is-hidden-touch">{{ user.created_at }} </td>
        <td>
            <button v-if="isAffiliate" class="button is-theme-primary"
                    @click.prevent="loginAsThisUser(user)">Login as {{ user.name }}</button>
        </td>
    </tr>
</template>

<script>
    import apiUsers from './../../api/apiUsers'
    export default {
        props: ['user'],
        data() {
            return {
                isActive: false
            }
        },
        computed : {
            isAffiliate() {
                if (this.$store.getters.getUserRole === 'Affiliate') {
                    return true
                }
            }
        },
        methods: {
            goToUserPage(id){
                if (this.$store.getters.getUserRole === 'Affiliate') {
                    return false;
                }
                this.$router.push({ name: 'EditUser', params: { id: id } });
            },
            loginAsThisUser(user) {
                let data = {
                    user: user
                }
                apiUsers
                    .loginAsOtherUser(data)
                    .then((response) => {
                        this.$store.commit('removeToken')
                        this.$store.commit('removeRole')
                        this.$store.commit('removeUserName')
                        this.$store.commit('updateToken', response.data.token)
                        this.$store.commit('updateRole', response.data.role)
                        this.$store.commit('updateUserReferer', (response.data.referer || response.data.role == 'Affiliate') ? 1 : 0 )
                        this.$store.commit('updateUserName', response.data.name)
                        this.$store.commit('updateUserDeposit', response.data.deposit)
                        this.$store.commit('updateUserDepositRate', response.data.rate)
                        this.$store.commit('updateUserDueAmount', response.data.due)
                        this.$store.dispatch('setCurrentUserCarHiddenFields', response.data.car_hidden_fields)
                        this.$router.push({ path: '/system' })
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        }
    }
</script>

<style scoped>
    tr:hover {
        background-color: rgba(128, 128, 128, 0.19);
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Users/UsersTableRow.vue